import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Axios from 'axios';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as DOMPurify from 'dompurify';
import { domain } from '../env';

export const HeadEn = () => {
    const [setting, setStting] = useState([])
    const [input, setInput] = useState('') //for search
    const [output, setOutput] = useState([]) //for search results
    const [loading, setLoading] = useState(true);
    const [searching, setSearching] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    
    // Get current location to check which page we're on
    const location = useLocation();
    
    // Only fetch the settings data which is needed for the header
    const getSetting = async () => {
        try {
            const response = await Axios({
                method: "get",
                url: `${domain}/api/setting/`
            });
            setStting(response.data);
        } catch (error) {
            console.error("Error fetching settings:", error);
        } finally {
            setLoading(false);
        }
    }
    
    // This effect runs once to get the settings
    useEffect(() => {
        getSetting();
    }, []);
    
    // Toggle search popup
    const handleSearchToggle = (e) => {
        if (e) e.preventDefault();
        setSearchOpen(!searchOpen);
        if (!searchOpen) {
            setInput('');
            setOutput([]);
        }
    }
    
    // Debounce search to avoid too many requests
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (input && input.length >= 2) {
                performSearch(input);
            } else {
                setOutput([]);
            }
        }, 500); // 500ms delay

        return () => clearTimeout(delayDebounceFn);
    }, [input]);

    // Search using backend API
    const performSearch = async (query) => {
        if (!query || query.length < 2) return;
        
        setSearching(true);
        try {
            const response = await Axios({
                method: "get",
                url: `${domain}/api/search/?q=${encodeURIComponent(query)}`
            });
            
            if (response.data && response.data.results) {
                setOutput(response.data.results);
            } else {
                setOutput([]);
            }
        } catch (error) {
            console.error("Search error:", error);
            setOutput([]);
        } finally {
            setSearching(false);
        }
    };

    return (
        <>
            <div className="application"></div>
            
            <header className="main-header clearfix">
                {/* Settings data */}
                {setting && setting.map((sa) => (
                    <div className="main-header__top" key={sa.id}>
                        <div className="main-header__top-left">
                            <p className="main-header__top-text">Welcome to Youth Planet.</p>
                            <div className="main-header__top-social">
                                <a href={`/${sa?.twitter_link}`}><i className="fab fa-twitter"></i></a>
                                <a href={`/${sa?.facebook_link}`}><i className="fab fa-facebook"></i></a>
                                <a href={`/${sa?.linkedin_link}`}><i className="fab fa-linkedin"></i></a>
                                <a href={`/${sa?.instagram_link}`}><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                        <div className="main-header__top-right">
                            <ul className="list-unstyled main-header__top-address">
                                <li>
                                    <div className="icon">
                                        <span className="icon-pin"></span>
                                    </div>
                                    <div className="text">
                                        <p>{sa?.addressEn}</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <span className="icon-email"></span>
                                    </div> 
                                    <div className="text">
                                        <p><a href="#">{sa?.email}</a></p>
                                       
                                    </div>
                                    {/* <div className="text">
                                        <p><a href='https://bn.youthplanet.org.bd/' style={{'backgroundColor':'#A020F0','color':'#fff','padding':'2px 15px','borderRadius':'10px 100px / 120px','marginLeft':'20px'}}>বাংলা</a></p>
                                       
                                    </div> */}
                                </li>
                            </ul>
                        </div>
                    </div>
                ))}

                <nav className="main-menu clearfix">
                    <div className="main-menu-wrapper clearfix">
                        {/* Logo and contact info */}
                        {setting && setting.map((sa) => (
                            <div className="main-menu-wrapper__left" key={sa.id}>
                                <div className="main-menu-wrapper__logo">
                                <LazyLoadImage 
                                            effect="blur" 
                                            src={`${domain}${sa?.logo}`}
                                            style={{'height':'80px','marginTop':'-40px','position':'absolute','marginLeft':'-40px','padding':'10px'}}
                                    />
                                </div>
                                <div className="main-menu-wrapper__call">
                                    <div className="main-menu-wrapper__call-icon">
                                        <span className="icon-call"></span>
                                    </div>
                                    <div className="main-menu-wrapper__call-number">
                                        <p>Call Anytime</p>
                                        <h5><a>+ 88 {sa?.phoneEn}</a></h5>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* Navigation menu */}
                        <div className="main-menu-wrapper__main-menu">
                            <a href="#" className="mobile-nav__toggler"><i className="fa fa-bars"></i></a>
                            <ul className="main-menu__list">
                                <li className={location.pathname === "/" ? "current" : ""}>
                                    <a href="/">HOME</a>
                                </li>
                                <li className={location.pathname === "/about" ? "current" : ""}>
                                    <a href="/about">ABOUT</a>
                                </li>
                                <li className={location.pathname === "/scarsv" ? "current" : ""}>
                                    <a href="/scarsv">ACTIVITIES</a>
                                </li>
                                <li className={location.pathname === "/achivement" ? "current" : ""}>
                                    <a href="/achivement">ACHIEVEMENT</a>
                                </li>
                                <li className={location.pathname === "/mediagallery" ? "current" : ""}>
                                    <a href="/mediagallery">MEDIA GALLERY</a>
                                </li>
                                <li className={location.pathname === "/allblog" ? "current" : ""}>
                                    <a href="/allblog">BLOG</a>
                                </li>
                                <li className={location.pathname === "/contact" ? "current" : ""}>
                                    <a href="/contact">CONTACT</a>
                                </li>
                            </ul>
                        </div>
                        
                        {/* Search icon */}
                        <div className="main-menu-wrapper__right">
                            <div className="main-menu-wrapper__search-cat">
                                <a href="#" 
                                   className="main-menu-wrapper__search search-toggler icon-magnifying-glass"
                                   onClick={handleSearchToggle}>
                                </a>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            {/* Mobile Nav */}
            <div className="mobile-nav__wrapper">
                <div className="mobile-nav__overlay mobile-nav__toggler"></div>
                <div className="mobile-nav__content">
                    <span className="mobile-nav__close mobile-nav__toggler"><i className="fa fa-times"></i></span>

                    <div className="logo-box">
                        {/* <a href="/" aria-label="logo image"><img src="assets/images/resources/logo-2.png" alt="" /></a> */}
                    </div>
                
                    <div className="mobile-nav__container"></div>
                    
                    {setting && setting.map((sa) => (
                        <>
                    <ul className="mobile-nav__contact list-unstyled">
                        <li>
                            <i className="fa fa-envelope"></i>
                            <a href="#">{sa?.email}</a>
                        </li>
                        <li>
                            <i className="fa fa-phone-alt"></i>
                            <a href='#'>{sa?.phoneEn}</a>
                        </li>
                    </ul>
                    <div className="mobile-nav__top">
                        <div className="mobile-nav__social">
                                <a href={`/${sa?.twitter_link}`}><i className="fab fa-twitter"></i></a>
                                <a href={`/${sa?.facebook_link}`}><i className="fab fa-facebook"></i></a>
                                <a href={`/${sa?.linkedin_link}`}><i className="fab fa-linkedin"></i></a>
                                <a href={`/${sa?.instagram_link}`}><i className="fab fa-instagram"></i></a>
                        </div>
                    </div>
                    </>
                    ))}


                </div>
                
            </div>

            {/* Search Popup */}
            <div className={`search-popup ${searchOpen ? 'active' : ''}`}>
                <div className="search-popup__overlay search-toggler" onClick={handleSearchToggle}></div>
                <div className="search-popup__content">
                    <form action="#" onSubmit={(e) => e.preventDefault()}>
                        <label htmlFor="search" className="sr-only">search here</label>
                        <input 
                            type="text" 
                            onChange={(e) => setInput(e.target.value)} 
                            value={input}
                            id="search" 
                            placeholder="Search activities (min 2 characters)" 
                        />
                        <button type="submit" aria-label="search submit" className="thm-btn">
                            {searching ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                                <i className="icon-magnifying-glass"></i>
                            )}
                        </button>
                        
                        {/* Search results display */}
                        <div className="search-results">
                            {input.length >= 2 && output.length > 0 ? (
                                output.map((item) => (
                                    <a 
                                        href={`/scarsvdetails${item?.id}`} 
                                        key={item.id} 
                                        className="search-result-item"
                                    >
                                        <div className="search-result-title">
                                            {item.title_english}
                                        </div>
                                        {item.details_English && (
                                            <div className="search-result-snippet" 
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        item.details_English.slice(0, 100) + '...'
                                                    )
                                                }}
                                            />
                                        )}
                                    </a>
                                ))
                            ) : input.length >= 2 && !searching ? (
                                <div className="no-results">No activities found matching your search</div>
                            ) : null}
                            
                            {searching && input.length >= 2 && (
                                <div className="searching-indicator">
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span className="searching-text">Searching...</span>
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>

            {/* Add CSS for improved search UI */}
            <style dangerouslySetInnerHTML={{
                __html: `
                    .search-popup {
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.3s ease;
                    }
                    
                    .search-popup.active {
                        opacity: 1;
                        visibility: visible;
                    }
                    
                    .search-results {
                        margin-top: 20px;
                        max-height: 400px;
                        overflow-y: auto;
                    }
                    
                    .search-result-item {
                        display: block;
                        background-color: #fff;
                        margin-bottom: 10px;
                        padding: 15px;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        text-decoration: none;
                        transition: transform 0.2s ease;
                    }
                    
                    .search-result-item:hover {
                        transform: translateY(-3px);
                    }
                    
                    .search-result-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #333;
                        margin-bottom: 5px;
                    }
                    
                    .search-result-snippet {
                        font-size: 14px;
                        color: #666;
                    }
                    
                    .no-results, .searching-indicator {
                        background-color: #fff;
                        padding: 15px;
                        border-radius: 8px;
                        margin-top: 10px;
                        text-align: center;
                    }
                    
                    .no-results {
                        color: #dc3545;
                    }
                    
                    .searching-indicator {
                        color: #0d6efd;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .searching-text {
                        margin-left: 8px;
                    }
                `
            }} />
        </>
    );
};
